import React, { useEffect, useState, useRef, useCallback } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useUser } from "../../context/Usercontext";
import { v4 as uuidv4 } from "uuid";
import "./Viewer.css"
import "./pdfviewer.css"
import zoomIn from './export-zoomin.svg'
import zoomOut from './ri_subtract-fill.svg'
import downloadIcon from './download.svg';
import darkModeIcon from './export-moon.svg';
import lightModeIcon from './export-sun.svg';
import Search_lite from './search_iocn_lite.svg'
import Search_Black from './search_icon_black.svg'
import close_icon from './close_icon.svg'
import AI_Icon from './Ai-magic-wand 1.svg'
import zoomInlite from './export-zoomin_lite.svg'
import zoomoutlite from './ri_subtract-fill_lite.svg'
import darkModeIconlite from './export-moon_lite.svg';
import lightModeIconlite from './export-sun_lite.svg';
import downloadIconlite from './downlaod_lite.svg';
import sendnowlite from './sendnow_lite.svg'
import arrow from './export.svg'
import LoadingWave from "../Loader";
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import { Modal, List, Input, Button, Spin, message } from 'antd';
import axios from 'axios';
import { CloseOutlined } from '@ant-design/icons';
import LeadCaptureForm from "./LeadCaptureForm";
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';
import { Select, Drawer } from 'antd';
import CookiePolicyModal from "./CookiePolicy";


const MyPdfViewer = ({ url, mimeType, totalPages, logoUrl,
    downloadEnabled, aiAgentEnabled, delaySeconds, scrollPercent }) => {
    console.log(mimeType, "mimetype");
    console.log(url, mimeType, totalPages, logoUrl, downloadEnabled,
        aiAgentEnabled, delaySeconds, scrollPercent, "props");

    const { ip, location, userId, region, os, device, browser } = useUser();
    console.log(ip, location, userId, region, os, device, browser, "dataaaaaaa");
    console.log(window.location.pathname);
    console.log(userId, "userid");

    const [currentPage, setCurrentPage] = useState(1);
    const [darkMode, setDarkMode] = useState(true);
    const [totalPagess, setTotalPagess] = useState(0);
    const [showLeadCapture, setShowLeadCapture] = useState(false);
    const [hasTriggeredScrollCapture, setHasTriggeredScrollCapture] =
        useState(false);

    // Search state variables - NEW inline search UI
    const [searchExpanded, setSearchExpanded] = useState(false);
    const [searchQueryText, setSearchQueryText] = useState('');
    const [pdfMatches, setPdfMatches] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const searchInputRef = useRef(null);

    const toggleTheme = () => setDarkMode(prev => !prev);

    const zoomPluginInstance = zoomPlugin();
    const zoomPluginRef = useRef(zoomPluginInstance);
    const { ZoomInButton, ZoomOutButton } = zoomPluginRef.current;
    const [zoomLevel, setZoomLevel] = useState(1.5);
    const pageNavigationPluginInstance = pageNavigationPlugin();
    const { jumpToPage } = pageNavigationPluginInstance;

    // Summary modal state variables
    const [summaryPopupVisible, setSummaryPopupVisible] = useState(false);
    const [summaryData, setSummaryData] = useState([]);
    const [showThumbnailModal, setShowThumbnailModal] = useState(false);
    const [summaryLoading, setSummaryLoading] = useState(false);

    // Add these state variables with your existing useState declarations
    const [showThumbnails, setShowThumbnails] = useState(false);
    const [thumbnails, setThumbnails] = useState([]);

    // Add thumbnail plugin instance with your existing plugin instances
    const thumbnailPluginInstance = thumbnailPlugin();
    const { Thumbnails } = thumbnailPluginInstance;

    const generateThumbnails = async (pdfDoc) => {
        if (!pdfDoc) return;

        try {
            const thumbs = [];
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            for (let i = 1; i <= Math.min(pdfDoc.numPages, 50); i++) { // Limit to 50 pages for performance
                try {
                    const page = await pdfDoc.getPage(i);
                    const viewport = page.getViewport({ scale: 0.2 }); // Small scale for thumbnails

                    canvas.width = viewport.width;
                    canvas.height = viewport.height;

                    await page.render({
                        canvasContext: context,
                        viewport: viewport
                    }).promise;

                    const thumbnailDataURL = canvas.toDataURL('image/jpeg', 0.5);
                    thumbs.push({
                        pageNumber: i,
                        thumbnail: thumbnailDataURL,
                        width: viewport.width,
                        height: viewport.height
                    });
                } catch (pageError) {
                    console.error(`Error generating thumbnail for page ${i}:`, pageError);
                }
            }

            setThumbnails(thumbs);
        } catch (error) {
            console.error('Error generating thumbnails:', error);
        }
    };

    // Add thumbnail click handler function
    const handleThumbnailClick = (pageNumber) => {
        console.log('Thumbnail clicked for page:', pageNumber);

        try {
            // Jump to the page (PDF.js uses 0-based indexing)
            jumpToPage(pageNumber - 1);

            // Update current page state
            setCurrentPage(pageNumber);

            // Update page input to keep it in sync
            setPageInput(String(pageNumber));

            console.log(`Navigated to page ${pageNumber} from thumbnail`);

            // Optional: Add a small delay before scrolling
            setTimeout(() => {
                const viewer = document.querySelector('.rpv-core__viewer');
                if (viewer) {
                    const pageElements = viewer.querySelectorAll('.rpv-core__inner-page');
                    if (pageElements[pageNumber - 1]) {
                        pageElements[pageNumber - 1].scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            }, 200);

        } catch (error) {
            console.error('Error navigating from thumbnail:', error);
            message.error(`Failed to navigate to page ${pageNumber}`);
        }
    };
    useEffect(() => {
        if (!pageInput || pageInput !== String(currentPage)) {
            setPageInput(String(currentPage));
        }
    }, [currentPage]);

    // Function to handle summarization
    const handleSummarize = async () => {
        if (!fileUrl) {
            message.error('No PDF loaded');
            return;
        }

        setSummaryLoading(true);
        setSummaryPopupVisible(true);

        try {
            // Extract document ID from URL
            const documentId = window.location.pathname.split("/").pop();

            console.log('🚀 Starting summarization for document:', documentId);
            console.log('📄 PDF URL:', fileUrl);

            const response = await axios.post('https://sendnow-backend-admin.onrender.com/api/v1/summarize', {
                pdfUrl: fileUrl,
                documentId: documentId
            });

            setSummaryData(response.data.summaries);
            message.success('PDF summarized successfully!');

            console.log('✅ Summarization completed:', response.data);

        } catch (error) {
            console.error('❌ Summarization error:', error);

            // More detailed error handling
            if (error.response) {
                // Server responded with error status
                const errorMessage = error.response.data?.error || 'Server error occurred';
                message.error(`Failed to summarize PDF: ${errorMessage}`);
                console.error('Server error details:', error.response.data);
            } else if (error.request) {
                // Request was made but no response received
                message.error('Network error - please check your connection');
                console.error('Network error:', error.request);
            } else {
                // Something else happened
                message.error('Failed to summarize PDF');
                console.error('Unexpected error:', error.message);
            }

            setSummaryData([]);
        } finally {
            setSummaryLoading(false);
        }
    };
    // Fixed useEffect for delay-based lead capture trigger
    useEffect(() => {
        console.log('Lead capture useEffect triggered with delaySeconds:',
            delaySeconds, typeof delaySeconds);
        setShowLeadCapture(false);
        setHasTriggeredScrollCapture(false);
        if (delaySeconds !== undefined && delaySeconds !== null) {
            const delay = Number(delaySeconds);
            if (!isNaN(delay) && delay > 0) {
                console.log(`Setting lead capture timer for ${delay} seconds`);
                const timer = setTimeout(() => {
                    console.log('Lead capture timer triggered after', delay, 'seconds');
                    setShowLeadCapture(true);
                }, delay * 1000);

                return () => {
                    console.log('Cleaning up lead capture timer');
                    clearTimeout(timer);
                };
            } else {
                console.warn('Invalid delaySeconds value:', delaySeconds, 'Type:',
                    typeof delaySeconds);
            }
        } else {
            console.log('No delaySeconds provided');
        }
    }, [delaySeconds]);

    // Also fix the scroll-based trigger to avoid conflicts
    useEffect(() => {
        console.log('Scroll trigger useEffect:', {
            scrollPercent, totalPagess,
            currentPage, hasTriggeredScrollCapture
        });
        if (scrollPercent && totalPagess > 0 && !hasTriggeredScrollCapture &&
            !showLeadCapture && !delaySeconds) {
            const scrollPercentNum = Number(scrollPercent);
            if (!isNaN(scrollPercentNum) && scrollPercentNum > 0) {
                const targetPage = Math.ceil((totalPagess * scrollPercentNum) / 100);
                console.log(`Checking scroll trigger: currentPage=${currentPage},
targetPage=${targetPage}`);
                if (currentPage >= targetPage) {
                    console.log(`Scroll trigger activated at page ${currentPage}, target
was ${targetPage}`);
                    setShowLeadCapture(true);
                    setHasTriggeredScrollCapture(true);
                }
            }
        }
    }, [scrollPercent, totalPagess, currentPage,
        hasTriggeredScrollCapture, showLeadCapture, delaySeconds]);

    // Add initial state management
    useEffect(() => {
        console.log('Component mounted with props:', {
            delaySeconds,
            scrollPercent, showLeadCapture
        });
        if (showLeadCapture) {
            setShowLeadCapture(false);
        }
    }, []);

    const closeSummaryPopup = () => {
        setSummaryPopupVisible(false);
    };

    // Function to navigate to specific page from summary
    const goToPageFromSummary = (pageNumber) => {
        if (pageNavigationPluginInstance) {
            jumpToPage(pageNumber - 1);
            setCurrentPage(pageNumber);
            setPageInput(String(pageNumber));
        }
    };

    const handleZoomIn = () => {
        const newZoom = Math.min(zoomLevel + 0.2, 3);
        zoomPluginRef.current.zoomTo(newZoom);
        setZoomLevel(newZoom);
    };

    const handleZoomOut = () => {
        const newZoom = Math.max(zoomLevel - 0.2, 0.5);
        zoomPluginRef.current.zoomTo(newZoom);
        setZoomLevel(newZoom);
    };

    const [pageInput, setPageInput] = useState('');
    const viewerRef = useRef(null);

    const goToPage = (e) => {
        e.preventDefault();
        const pageNum = parseInt(pageInput, 10);

        console.log('goToPage called with:', pageNum, 'Total pages:', totalPagess);

        // Validate page number
        if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPagess) {
            try {
                console.log(`Attempting to jump to page ${pageNum}`);

                // Jump to the page (PDF.js uses 0-based indexing)
                jumpToPage(pageNum - 1);

                // Update current page state immediately
                setCurrentPage(pageNum);

                // Force update pageInput to ensure consistency
                setPageInput(String(pageNum));

                console.log(`Successfully jumped to page ${pageNum}`);

                // Optional: Scroll the page into view after a small delay
                setTimeout(() => {
                    const viewer = document.querySelector('.rpv-core__viewer');
                    if (viewer) {
                        const pageElements = viewer.querySelectorAll('.rpv-core__inner-page');
                        if (pageElements[pageNum - 1]) {
                            pageElements[pageNum - 1].scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }
                }, 200); // Increased delay for better reliability

            } catch (error) {
                console.error('Error jumping to page:', error);
                message.error(`Failed to jump to page ${pageNum}`);
            }
        } else {
            console.warn(`Invalid page number: ${pageNum}. Must be between 1 and ${totalPagess}`);
            message.error(`Please enter a valid page number (1-${totalPagess})`);
            // Reset input to current page if invalid
            setPageInput(String(currentPage));
        }
    };
    // Auto download handler
    const handleDownload = async () => {
        ignoreLinkRef.current = true;

        try {
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error('Network error');
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileUrl.split('/').pop() || 'download.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error('Download failed', err);
        } finally {
            setTimeout(() => {
                ignoreLinkRef.current = false;
            }, 500);
        }
    };

    // NEW: Inline search functions - Updated UI, same functionality
    const toggleSearch = () => {
        if (searchExpanded) {
            setSearchExpanded(false);
            setSearchQueryText('');
            setPdfMatches([]);
        } else {
            setSearchExpanded(true);
            setTimeout(() => searchInputRef.current?.focus(), 100);
        }
    };

    // ORIGINAL: Extract snippet function - unchanged
    const extractSnippet = (text, keyword) => {
        const index = text.toLowerCase().indexOf(keyword.toLowerCase());
        if (index === -1) return '';
        const start = Math.max(index - 25, 0);
        const end = Math.min(index + 50, text.length);
        return text.substring(start, end) + '...';
    };

    // ORIGINAL: PDF search function - same functionality, just UI changes
    const performPdfSearch = async () => {
        const keyword = searchQueryText.trim();
        if (!pdfDocumentInstance || !keyword) return;

        setSearchLoading(true);

        // Track search keywords for analytics (original functionality)
        if (!searchKeywordsRef.current.includes(keyword)) {
            searchKeywordsRef.current.push(keyword);
            setSearchKeywords([...searchKeywordsRef.current]);
        }

        const results = [];
        const lowerKeyword = keyword.toLowerCase();

        try {
            // Original search logic - search through all pages
            for (let i = 1; i <= pdfDocumentInstance.numPages; i++) {
                const page = await pdfDocumentInstance.getPage(i);
                const textContent = await page.getTextContent();
                const fullText = textContent.items.map(item => item.str).join(' ');
                if (fullText.toLowerCase().includes(lowerKeyword)) {
                    results.push({
                        pageNum: i,
                        snippet: extractSnippet(fullText, keyword),
                    });
                }
            }
            setPdfMatches(results);
        } catch (error) {
            console.error('Search error:', error);
        } finally {
            setSearchLoading(false);
        }
    };

    // FIXED: Handle match click - improved page navigation
    const handleMatchClick = (pgNum) => {
        try {
            // Ensure the page number is valid
            if (pgNum >= 1 && pgNum <= totalPagess) {
                // Jump to the page (PDF.js uses 0-based indexing)
                jumpToPage(pgNum - 1);
                // Update current page state
                setCurrentPage(pgNum);
                // Update page input field
                setPageInput(String(pgNum));
                // Add a small delay to ensure the page navigation completes
                setTimeout(() => {
                    // Scroll the page into view if needed
                    const viewer = document.querySelector('.rpv-core__viewer');
                    if (viewer) {
                        const pageElements = viewer.querySelectorAll('.rpv-core__inner-page');
                        if (pageElements[pgNum - 1]) {
                            pageElements[pgNum - 1].scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }
                }, 100);
                console.log(`Navigating to page ${pgNum} from search results`);
            } else {
                console.error(`Invalid page number: ${pgNum}. Total pages: ${totalPagess}`);
            }
        } catch (error) {
            console.error('Error navigating to page:', error);
        }
        // Keep search open for additional searches
    };

    // FIXED: PDF load handler - use consistent state setter
    const onPdfLoad = async (doc) => {
        try {
            setPdfDocumentInstance(doc);
            setTotalPagess(doc.numPages);
            console.log(`PDF loaded with ${doc.numPages} pages`);

            // Update analytics data with total pages
            setAnalyticsData((prevData) => ({
                ...prevData,
                totalPages: doc.numPages,
            }));

            // Generate thumbnails after PDF loads
            if (pdfjs) {
                // Load the PDF document using pdfjs for thumbnail generation
                try {
                    const loadingTask = pdfjs.getDocument(fileUrl);
                    const pdfDocument = await loadingTask.promise;
                    await generateThumbnails(pdfDocument);
                } catch (thumbnailError) {
                    console.error('Error loading PDF for thumbnails:', thumbnailError);
                }
            }
        } catch (error) {
            console.error('Error loading PDF:', error);
        }
    };

    const [pdfjs, setPdfjs] = useState(null);
    const [pdfjsWorker, setPdfjsWorker] = useState(null);

    // Refs for tracking per-page time, timers, and analytics call status.
    const timeSpentRef = useRef({});
    const pageTimerRef = useRef(null);
    const visitedPagesRef = useRef(new Set());
    const milestoneVisitedPagesRef = useRef(0);
    const apiCalledRef = useRef(false);
    const ignoreLinkRef = useRef(false);

    // Ref to capture when the user leaves the tab.
    const lastLeaveTimeRef = useRef(null);
    const autoCloseTimerRef = useRef(null);

    const sessionIdRef = useRef(uuidv4());

    // State variables for tracking user interactions for analytics.
    const [totalClicks, setTotalClicks] = useState(0);
    const [selectedTexts, setSelectedTexts] = useState([]);
    const [linkClicks, setLinkClicks] = useState([]);
    const [pageVisitCount, setPageVisitCount] = useState({});
    const [isMobile, setIsMobile] = useState(false);
    const [searchKeywords, setSearchKeywords] = useState([]);
    const searchKeywordsRef = useRef([]);
    const [pdfDocumentInstance, setPdfDocumentInstance] = useState(null);

    const [helpModalVisible, setHelpModalVisible] = useState(false);

    // 2. Add these handler functions with your other functions (around line 200-300)
    const openHelpModal = () => {
        setHelpModalVisible(true);
    };

    const closeHelpModal = () => {
        setHelpModalVisible(false);
    };

    const fileUrl = url;

    // Set up initial analytics data.
    const [analyticsData, setAnalyticsData] = useState({
        ip: ip || "",
        location: location || "",
        userId: userId || "",
        region: region || "",
        os: os || "",
        device: device || "",
        browser: browser || "",
        pdfId: window.location.pathname.split("/").pop() || "",
        sourceUrl: url,
        totalPagesVisited: 0,
        totalTimeSpent: 0,
        pageTimeSpent: {},
        selectedTexts: [],
        totalClicks: 0,
        inTime: new Date().toISOString(),
        outTime: null,
        mostVisitedPage: null,
        linkClicks: [],
        totalPages: 0,
    });

    // A ref to always have the latest analyticsData.
    const analyticsDataRef = useRef(analyticsData);
    useEffect(() => {
        analyticsDataRef.current = analyticsData;
    }, [analyticsData, selectedTexts, totalClicks, linkClicks]);

    // Get userId from localStorage and sessionStorage.
    const localStorageUserId = localStorage.getItem("userId");
    const sessionStorageUserId = sessionStorage.getItem("userId");

    // Identification API call: fires once after 3 seconds if userId is valid.
    const sendIdentificationRequest = useCallback(async () => {
        if (!userId || !window.location.pathname) return;

        const documentId = window.location.pathname.split("/").pop();
        const requestData = {
            userId, documentId, mimeType: "pdf", sessionId:
                sessionIdRef.current
        };

        try {
            const response = await
                fetch("https://user-view-backend-v1.onrender.com/api/user/identify", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });
            if (!response.ok) throw new Error("Failed to identify user");
            const result = await response.json();
            console.log("User identification successful:", result);
        } catch (error) {
            console.error("Error sending identification request:", error);
        }
    }, [userId]);

    useEffect(() => {
        if (userId && userId.length > 15 && !apiCalledRef.current) {
            const timer = setTimeout(() => {
                sendIdentificationRequest();
                apiCalledRef.current = true;
            }, 10000);

            return () => clearTimeout(timer);
        }
    }, [userId, sendIdentificationRequest]);

    // Handle userId API calls based on localStorage and sessionStorage.
    useEffect(() => {
        if (apiCalledRef.current) return;
        const delay = 1000;

        const timer = setTimeout(() => {
            const isDataReady =
                ip &&
                location &&
                userId &&
                region &&
                os &&
                device &&
                browser &&
                !ip.includes("Detecting") &&
                !location.includes("Detecting") &&
                !userId.includes("Detecting") &&
                !region.includes("Detecting") &&
                !os.includes("Detecting") &&
                !device.includes("Detecting") &&
                !browser.includes("Detecting");

            if (localStorageUserId && sessionStorageUserId && localStorageUserId
                === sessionStorageUserId) {
                apiCalledRef.current = true;
            } else if (!localStorageUserId && !sessionStorageUserId && isDataReady
                && userId) {
                apiCalledRef.current = true;
            }
        }, delay);

        return () => clearTimeout(timer);
    }, [localStorageUserId, sessionStorageUserId, userId, ip, location,
        region, os, device, browser]);

    useEffect(() => {
        if (device && device !== "Detecting...") {
            setIsMobile(device.toLowerCase().includes("mobile"));
        }
    }, [device]);

    // Update analyticsData when context values change.
    useEffect(() => {
        setAnalyticsData((prevData) => ({
            ...prevData,
            ip: ip || "",
            location: location || "",
            userId: userId || "",
            region: region || "",
            os: os || "",
            device: device || "",
            browser: browser || "",
        }));
    }, [ip, location, userId, region, os, device, browser]);

    // Dynamically load pdfjs and its worker.
    useEffect(() => {
        const loadPdfjs = async () => {
            const pdfjsModule = await import("pdfjs-dist/build/pdf");
            const pdfjsWorkerModule = await import("pdfjs-dist/build/pdf.worker.entry");
            pdfjsModule.GlobalWorkerOptions.workerSrc = pdfjsWorkerModule;
            setPdfjs(pdfjsModule);
            setPdfjsWorker(pdfjsWorkerModule);
        };
        loadPdfjs();
    }, []);

    // Start or restart the per-page time tracking timer.
    const startPageTimer = useCallback(() => {
        clearInterval(pageTimerRef.current);
        pageTimerRef.current = setInterval(() => {
            const page = currentPage;
            timeSpentRef.current[page] = (timeSpentRef.current[page] || 0) + 1;
            setAnalyticsData((prevData) => ({
                ...prevData,
                totalTimeSpent: prevData.totalTimeSpent + 1,
                pageTimeSpent: {
                    ...prevData.pageTimeSpent,
                    [page]: (prevData.pageTimeSpent[page] || 0) + 1,
                },
            }));
        }, 1000);
    }, [currentPage]);

    // Handle page changes.
    const handlePageChange = useCallback(
        (e) => {
            const newPage = e.currentPage + 1;
            clearInterval(pageTimerRef.current);

            if (document.visibilityState === "visible") {
                startPageTimer();
            }

            visitedPagesRef.current.add(newPage);
            const visitedPagesCount = visitedPagesRef.current.size;

            if (visitedPagesCount >= milestoneVisitedPagesRef.current + 10) {
                milestoneVisitedPagesRef.current = Math.floor(visitedPagesCount / 10) * 10;
                console.log(`Visited Pages Milestone:
${milestoneVisitedPagesRef.current} pages visited.`);
            }

            setAnalyticsData((prevData) => ({
                ...prevData,
                totalPagesVisited: visitedPagesCount,
            }));

            setPageVisitCount((prevCount) => {
                const newCount = { ...prevCount, [newPage]: (prevCount[newPage] || 0) + 1 };
                let mostVisitedPage = null;
                let maxTimeSpent = 0;
                for (const [page, time] of Object.entries(timeSpentRef.current)) {
                    if (time > maxTimeSpent) {
                        mostVisitedPage = page;
                        maxTimeSpent = time;
                    }
                }
                setAnalyticsData((prevData) => ({
                    ...prevData,
                    mostVisitedPage: mostVisitedPage,
                }));
                return newCount;
            });

            setCurrentPage(newPage);
        },
        [startPageTimer]
    );

    // Track text selection on the PDF.
    const handleTextSelection = useCallback(() => {
        const selectedText = window.getSelection().toString().trim();
        if (selectedText) {
            const truncatedText = selectedText.length > 300 ?
                selectedText.slice(0, 300) : selectedText;
            console.log(`Selected Text on page ${currentPage}: "${truncatedText}"`);

            setSelectedTexts((prevSelectedTexts) => {
                const existingText = prevSelectedTexts.find(
                    (item) => item.selectedText === truncatedText && item.page === currentPage
                );
                if (existingText) {
                    return prevSelectedTexts.map((item) =>
                        item.selectedText === truncatedText && item.page === currentPage
                            ? { ...item, count: item.count + 1 }
                            : item
                    );
                } else {
                    return [...prevSelectedTexts, {
                        selectedText: truncatedText, count: 1,
                        page: currentPage
                    }];
                }
            });
        }
    }, [currentPage]);

    // Intercept link clicks inside the PDF.
    const handleLinkClick = useCallback(
        (e) => {
            if (ignoreLinkRef.current) return;
            const linkElement = e.target.closest("a");
            if (linkElement) {
                e.preventDefault();
                const linkUrl = linkElement.href;
                console.log(`Link clicked on page ${currentPage}: ${linkUrl}`);
                window.open(linkUrl, "_blank");
                setLinkClicks((prevLinkClicks) => [
                    ...prevLinkClicks,
                    { page: currentPage, clickedLink: linkUrl },
                ]);
            }
        },
        [currentPage]
    );

    // General click handler to increment the click count.
    const handleClick = useCallback(() => {
        setTotalClicks((prev) => prev + 1);
    }, []);

    const analyticsIntervalRef = useRef(null);
    const absenceTimesRef = useRef([]);

    const startAnalyticsInterval = useCallback(() => {
        analyticsIntervalRef.current = setInterval(() => {
            let payloadOutTime;
            const currentTime = new Date();

            if (lastLeaveTimeRef.current) {
                const leaveTime = new Date(lastLeaveTimeRef.current);
                const absenceDurationMs = currentTime - leaveTime;
                const absenceSeconds = Math.round(absenceDurationMs / 1000);

                const computedOutTime = new Date(currentTime - absenceDurationMs).toISOString();

                console.log("timeformat");
                console.log(
                    `${currentTime.toISOString().replace("Z", "+00:00")} -
${absenceSeconds}s = ${computedOutTime.replace("Z", "+00:00")}`
                );

                absenceTimesRef.current.push({
                    leaveTime: leaveTime.toISOString(),
                    returnTime: currentTime.toISOString(),
                    absenceSeconds,
                    computedOutTime,
                });

                payloadOutTime = computedOutTime;
            } else {
                payloadOutTime = currentTime.toISOString();
            }

            lastLeaveTimeRef.current = null;

            const finalData = {
                ...analyticsDataRef.current,
                outTime: payloadOutTime,
                userId,
                sessionId: sessionIdRef.current,
                selectedTexts,
                totalClicks,
                linkClicks,
                searchKeywords: searchKeywordsRef.current,
                absenceHistory: absenceTimesRef.current,
            };

            const sendAnalyticsData = async () => {
                try {
                    const response = await
                        fetch("https://user-view-backend.vercel.app/api/PdfInfo/pdfpageinfo",
                            {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(finalData),
                            });
                    if (!response.ok) throw new Error("Network response was not ok");
                    const result = await response.json();
                    console.log("Periodic analytics data sent successfully:", result);
                } catch (error) {
                    console.error("Error sending periodic analytics data:", error);
                }
            };
            sendAnalyticsData();
        }, 10000);
    }, [userId, selectedTexts, totalClicks, linkClicks]);

    useEffect(() => {
        startAnalyticsInterval();
        return () => {
            clearInterval(analyticsIntervalRef.current);
        };
    }, [startAnalyticsInterval]);

    // Listen for page visibility changes.
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                lastLeaveTimeRef.current = new Date().toISOString();
                clearInterval(analyticsIntervalRef.current);
                analyticsIntervalRef.current = null;
                clearInterval(pageTimerRef.current);
                pageTimerRef.current = null;

                autoCloseTimerRef.current = setTimeout(() => {
                    console.log("Absence > 1 minute. Auto-closing the viewer.");
                    window.close();
                }, 600000);
            } else if (document.visibilityState === "visible") {
                if (lastLeaveTimeRef.current) {
                    const absenceDurationMs = new Date() - new Date(lastLeaveTimeRef.current);
                    if (absenceDurationMs >= 600000) {
                        console.log("User was absent for more than 1 minute. Auto-closing the viewer.");
                        window.close();
                        return;
                    }
                }

                if (autoCloseTimerRef.current) {
                    clearTimeout(autoCloseTimerRef.current);
                    autoCloseTimerRef.current = null;
                }
                if (!analyticsIntervalRef.current) {
                    startAnalyticsInterval();
                }
                if (!pageTimerRef.current) {
                    startPageTimer();
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange",
            handleVisibilityChange);
    }, [startAnalyticsInterval, startPageTimer]);

    // Simple throttle helper to limit execution frequency (for mobile events)
    const throttle = (func, delay) => {
        let lastCall = 0;
        return (...args) => {
            const now = Date.now();
            if (now - lastCall >= delay) {
                lastCall = now;
                func(...args);
            }
        };
    };

    useEffect(() => {
        const mobileTextSelection = throttle(handleTextSelection, 500);
        const mobileClickHandler = throttle(handleClick, 500);
        const mobileLinkClick = throttle(handleLinkClick, 500);

        const desktopTextSelection = handleTextSelection;
        const desktopClickHandler = handleClick;
        const desktopLinkClick = handleLinkClick;

        if (isMobile) {
            document.addEventListener("touchend", mobileTextSelection, { passive: true });
            document.addEventListener("touchend", mobileClickHandler, { passive: true });
            document.addEventListener("touchend", mobileLinkClick, { passive: true });
            return () => {
                document.removeEventListener("touchend", mobileTextSelection);
                document.removeEventListener("touchend", mobileClickHandler);
                document.removeEventListener("touchend", mobileLinkClick);
            };
        } else {
            document.addEventListener("mouseup", desktopTextSelection);
            document.addEventListener("click", desktopClickHandler);
            document.addEventListener("click", desktopLinkClick);
            return () => {
                document.removeEventListener("mouseup", desktopTextSelection);
                document.removeEventListener("click", desktopClickHandler);
                document.removeEventListener("click", desktopLinkClick);
            };
        }
    }, [handleTextSelection, handleClick, handleLinkClick, isMobile]);

    // Handle search input changes
    const handleSearchInputChange = (e) => {
        setSearchQueryText(e.target.value);
    };

    // Handle search on Enter key
    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            performPdfSearch();
        }
    };

    if (!pdfjs || !pdfjsWorker) {
        return <LoadingWave />;
    }

    const handleWidgetClick = () => {
        window.open("https://www.sendnow.live/", "_blank");
    };

    return (
        <div className={`main-background ${isMobile ? 'mobile-view' : ''}
${darkMode ? 'dark-theme' : 'light-theme'}`}>
            <div className={`dashboard-container ${isMobile ? 'mobile-container' : ''}`}>
                <div className="widget-header-bar">
                    {/* Custom or Default Logo */}
                    <img
                        src={logoUrl ? logoUrl : (darkMode ? sendnowlite : "/sendnow.svg")}
                        className="widget-logo"
                        alt="Logo"
                        onClick={handleWidgetClick}
                    />

                    <div className="widget-controls">
                        <div className={`search-container ${searchExpanded ? 'expanded' : ''}`}>
                            {!searchExpanded ? (
                                <button onClick={toggleSearch} className="icon-button" title="Search PDF">
                                    <img
                                        src={darkMode ? Search_lite : Search_Black}
                                        alt="Search"
                                        className="export-icon"
                                    />
                                </button>
                            ) : (
                                <div className="inline-search-expanded">
                                    <input
                                        ref={searchInputRef}
                                        type="text"
                                        value={searchQueryText}
                                        onChange={handleSearchInputChange}
                                        onKeyPress={handleSearchKeyPress}
                                        placeholder="Search text..."
                                        className="search-input"
                                    />
                                    <button
                                        onClick={performPdfSearch}
                                        className="search-button"
                                        disabled={searchLoading}
                                        title="Search"
                                    >
                                        {searchLoading ? 'Loading...' : 'Go'}
                                    </button>
                                    <button
                                        onClick={toggleSearch}
                                        className="search-close-button"
                                        title="Close Search"
                                    >
                                        ✕
                                    </button>
                                    {/* Search Results Dropdown - Enhanced click handling */}
                                    {pdfMatches.length > 0 && (
                                        <div className="search-results-dropdown">
                                            {pdfMatches.map((item, index) => (
                                                <div
                                                    key={index}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        console.log(`Clicked search result for page ${item.pageNum}`);
                                                        handleMatchClick(item.pageNum);
                                                    }}
                                                    className="search-result-item"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <strong>Page {item.pageNum}:</strong>
                                                    <span className="search-snippet">
                                                        {item.snippet.split(new RegExp(`(${searchQueryText})`,
                                                            'gi')).map((part, partIndex) =>
                                                                searchQueryText && part.toLowerCase() === searchQueryText.toLowerCase() ? (
                                                                    <span key={partIndex} className="search-highlight">
                                                                        {part}
                                                                    </span>
                                                                ) : (
                                                                    <span key={partIndex}>{part}</span>
                                                                )
                                                            )}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <button
                            onClick={() => setShowThumbnailModal(true)}
                            className="icon-button"
                            title="Show Thumbnails Grid"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 3H10V10H3V3ZM14 3H21V10H14V3ZM14 14H21V21H14V14ZM3 14H10V21H3V14Z"
                                    fill={darkMode ? '#ffffff' : '#000000'} />
                            </svg>
                        </button>
                        {/* Zoom Buttons */}
                        <button onClick={handleZoomIn} className="icon-button" title="Zoom In">
                            <img src={darkMode ? zoomInlite : zoomIn} alt="Zoom In"
                                className="export-icon" />
                        </button>
                        <button onClick={handleZoomOut} className="icon-button" title="Zoom Out">
                            <img src={darkMode ? zoomoutlite : zoomOut} alt="Zoom Out"
                                className="export-icon" />
                        </button>

                        {/* Page Jump */}
                        <form onSubmit={goToPage} className="page-jump-form">
                            <input
                                type="number"
                                value={pageInput}
                                onChange={(e) => setPageInput(e.target.value)}
                                placeholder="Page #"
                                className="page-jump-input"
                            />
                            <p>{totalPagess || 4}</p>
                            <button type="submit" className="page-jump-button">Go</button>
                        </form>

                        {/* Download if downloadEnabled */}
                        {downloadEnabled && (
                            <button onClick={handleDownload} className="icon-button" title="Download PDF">
                                <img
                                    src={darkMode ? downloadIconlite : downloadIcon}
                                    alt="Download"
                                    className="export-icon"
                                />
                            </button>
                        )}
                    </div>
                </div>

                {/* Help Modal */}
                <Modal
                    title={
                        <div className="help-modal-header">
                            <div className="help-modal-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" strokeWidth="2" />
                                    <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 17H12.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div>
                                <h3>Help & Support</h3>
                                <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>Get help with PDF viewer features</p>
                            </div>
                        </div>
                    }
                    open={helpModalVisible}
                    onCancel={closeHelpModal}
                    footer={null}
                    width={600}
                    className={`${darkMode ? 'custom-dark-modal' : ''} help-modal`}
                >
                    <div className="help-modal-content">
                        <div className="help-section">
                            <h4>Navigation Controls</h4>
                            <p>• Use zoom in/out buttons to adjust document size</p>
                            <p>• Enter page number and click 'Go' to jump to specific pages</p>
                            <p>• Scroll or use arrow keys to navigate through pages</p>
                        </div>

                        <div className="help-section">
                            <h4>Search Functionality</h4>
                            <p>• Click the search icon to open search bar</p>
                            <p>• Type your search term and press Enter or click 'Go'</p>
                            <p>• Click on search results to navigate to that page</p>
                        </div>

                        <div className="help-section">
                            <h4>Additional Features</h4>
                            <p>• Toggle between dark/light mode using the theme button</p>
                            <p>• Download the PDF if download is enabled</p>
                            <p>• Use AI summarize feature for document insights</p>
                        </div>

                        <div className="help-section">
                            <h4>Need More Help?</h4>
                            <p>Contact support at: <a href="mailto:support@sendnow.live">support@sendnow.live</a></p>
                        </div>
                    </div>
                </Modal>
                <Modal
                    title={
                        <div className="thumbnail-modal-header">
                            <div>
                                <h3>Document Preview</h3>
                            </div>
                        </div>
                    }
                    open={showThumbnailModal}
                    onCancel={() => setShowThumbnailModal(false)}
                    footer={null}
                    width={800}
                    className={`${darkMode ? 'custom-dark-modal' : ''} thumbnail-grid-modal`}
                >
                    <div className="thumbnail-grid-container">
                        {thumbnails.length === 0 ? (
                            <div className="thumbnail-loading">
                                <Spin size="large" />
                                <p style={{ marginTop: '16px', color: darkMode ? '#fff' : '#000' }}>
                                    Generating thumbnails...
                                </p>
                            </div>
                        ) : (
                            <div className="thumbnail-grid">
                                {thumbnails.map((thumb, index) => (
                                    <div
                                        key={thumb.pageNumber}
                                        className={`thumbnail-grid-item ${currentPage === thumb.pageNumber ? 'active' : ''}`}
                                        onClick={() => {
                                            handleThumbnailClick(thumb.pageNumber);
                                            setShowThumbnailModal(false);
                                        }}
                                        title={`Go to Page ${thumb.pageNumber}`}
                                    >
                                        <div className="thumbnail-image-container">
                                            <img
                                                src={thumb.thumbnail}
                                                alt={`Page ${thumb.pageNumber}`}
                                                className="thumbnail-grid-image"
                                                loading="lazy"
                                            />
                                            <div className="thumbnail-overlay">
                                                <span className="thumbnail-page-label">
                                                    Page {thumb.pageNumber}
                                                </span>
                                            </div>
                                        </div>
                                        {currentPage === thumb.pageNumber && (
                                            <div className="thumbnail-current-indicator">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </Modal>
                {/* PDF Viewer */}
                <Worker workerUrl={pdfjsWorker}>
                    <Viewer
                        fileUrl={fileUrl}
                        defaultScale={isMobile ? 0.6 : 1.5}
                        renderMode="canvas"
                        onPageChange={handlePageChange}
                        onDocumentLoad={({ doc }) => onPdfLoad(doc)}
                        plugins={[zoomPluginInstance, pageNavigationPluginInstance]}

                    />
                </Worker>

                {/* AI Chatbot - Bottom Right */}
                {aiAgentEnabled && (
                    <div
                        className="ai-chatbot-widget"
                        onClick={handleSummarize}
                        title="AI Summarize PDF"
                    >
                        <img
                            src={AI_Icon}
                            alt="AI Icon"
                        />
                    </div>
                )}
            </div>

            {/* Lead Capture Form */}
            {showLeadCapture && (
                <LeadCaptureForm
                    onClose={() => setShowLeadCapture(false)}
                    documentId={window.location.pathname.split("/").pop() || ""}
                />
            )}



            {/* Enhanced Summary Modal */}
            <Modal
                title={
                    <div className="enhanced-summary-modal-header">
                        <div className="summary-overview-header">
                            <div className="enhanced-summary-modal-icon-container">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944
21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21
12Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="enhanced-summary-modal-title">
                                    Document Summary
                                </h3>
                                <p className="enhanced-summary-modal-subtitle">
                                    AI-generated content overview
                                </p>
                            </div>
                        </div>
                        <button onClick={closeSummaryPopup} className="enhanced-summary-modal-close">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2"
                                    strokeLinecap="round" />
                            </svg>
                        </button>
                    </div>
                }
                open={summaryPopupVisible}
                onCancel={closeSummaryPopup}
                footer={null}
                width={900}
                className={`${darkMode ? 'custom-dark-modal' : ''} enhanced-summary-modal`}
                closable={false}
            >
                {summaryLoading ? (
                    <div className="summary-loading-container">
                        <div className={`summary-loading-icon ${darkMode ? 'dark-theme' :
                            'light-theme'}`}>
                            <Spin size="large" />
                        </div>
                        <div className={`summary-loading-title ${darkMode ? 'dark-theme' :
                            'light-theme'}`}>
                            Analyzing document...
                        </div>
                        <div className={`summary-loading-description ${darkMode ? 'dark-theme'
                            : 'light-theme'}`}>
                            Processing your PDF to extract key insights and create a comprehensive summary.
                        </div>
                    </div>
                ) : (
                    <div>
                        {summaryData.length === 0 ? (
                            <div className="summary-empty-container">
                                <div className={`summary-empty-icon ${darkMode ? 'dark-theme' :
                                    'light-theme'}`}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071
2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579
21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893
19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                                            stroke={darkMode ? '#666' : '#999'} strokeWidth="2"
                                            strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M14 2V8H20" stroke={darkMode ? '#666' : '#999'}
                                            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className={`summary-empty-title ${darkMode ? 'dark-theme' :
                                    'light-theme'}`}>
                                    No summary available
                                </h3>
                                <p className={`summary-empty-description ${darkMode ? 'dark-theme' :
                                    'light-theme'}`}>
                                    Unable to generate a summary for this document.
                                </p>
                            </div>
                        ) : (
                            <div>
                                <div className={`summary-overview ${darkMode ? 'dark-theme' : 'light-theme'}`}>
                                    <div className="summary-overview-header">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 17H7C6.46957 17 5.96086 16.7893 5.58579 16.4142C5.21071
16.0391 5 15.5304 5 15V5C5 4.46957 5.21071 3.96086 5.58579
3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071
18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V15C19 15.5304 18.7893
16.0391 18.4142 16.4142C18.0391 16.7893 17.5304 17 17 17H15"
                                                stroke={darkMode ? '#94a3b8' : '#64748b'} strokeWidth="2"
                                                strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M12 15L9 12L12 9" stroke={darkMode ? '#94a3b8' : '#64748b'}
                                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span className={`summary-overview-title ${darkMode ? 'dark-theme' :
                                            'light-theme'}`}>
                                            Summary Overview
                                        </span>
                                    </div>
                                    <div className={`summary-overview-stats ${darkMode ? 'dark-theme' :
                                        'light-theme'}`}>
                                        <div className="summary-stat-item">
                                            <div className="summary-stat-dot primary"></div>
                                            {summaryData.length} pages analyzed
                                        </div>
                                        <div className="summary-stat-item">
                                            <div className="summary-stat-dot success"></div>
                                            AI-powered insights
                                        </div>
                                        <div className="summary-stat-item">
                                            <div className="summary-stat-dot warning"></div>
                                            Key content extracted
                                        </div>
                                    </div>
                                </div>

                                <div className="summary-content-scroll">
                                    <List
                                        dataSource={summaryData}
                                        renderItem={(item, index) => (
                                            <List.Item className="summary-item-container">
                                                <div
                                                    className={`summary-item ${darkMode ? 'dark-theme' : 'light-theme'}`}
                                                    onClick={() => goToPageFromSummary(item.page)}
                                                >
                                                    <div className="summary-item-header">
                                                        <div className="summary-item-info">
                                                            <div className="summary-item-page-icon">
                                                                {item.page}
                                                            </div>
                                                            <div>
                                                                <h4 className={`summary-item-page-title ${darkMode ? 'dark-theme' :
                                                                    'light-theme'}`}>
                                                                    Page {item.page}
                                                                </h4>
                                                                <span className={`summary-item-page-subtitle ${darkMode ? 'dark-theme'
                                                                    : 'light-theme'}`}>
                                                                    Click to navigate
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <Button
                                                            size="small"
                                                            type="primary"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                goToPageFromSummary(item.page);
                                                            }}
                                                            className="summary-item-view-button"
                                                        >
                                                            View Page
                                                        </Button>
                                                    </div>
                                                    <div className={`summary-item-content ${darkMode ? 'dark-theme' :
                                                        'light-theme'}`}>
                                                        {item.summary}
                                                    </div>
                                                </div>
                                            </List.Item>
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Modal>
            <div className="sendnow-watermark" onClick={handleWidgetClick}>
                <div className="watermark-container">
                    <span className="watermark-text">Sharedocs via </span>
                    <span className="sendnow-brand">SendNow</span>
                </div>
            </div>
              <CookiePolicyModal darkMode={darkMode} />
        </div>
        
    );
};

export default MyPdfViewer;
